import React, { useState } from "react";
import Button from "../components/common/Button/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GoArrowLeft } from "react-icons/go";
import { imageUrl } from "../config/url";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { forgot_password, verifyLoginOTP, verifyOTP } from "../redux/actions/auth.action";
import ButtonLoading from "../components/custom/ButtonLoading";
import { useFormik } from "formik";
import OTPInput from "react-otp-input";
import { verifyOtpSchema } from "../config/schema";

const VerifyOtp = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const navigate = useNavigate();
  const { state } = useLocation();

  const handleChange = (index, value) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
  };
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth)

  const formik = useFormik({
    initialValues: {
      otp: ""
    },
    validationSchema: verifyOtpSchema,
    onSubmit: (values) => {
      if (state?.for == "login") {
        dispatch(verifyLoginOTP({
          otp: values?.otp,
          email: state?.email
        })).unwrap()
          .then((res) => {
            if (localStorage.getItem("role") == "admin") {
              navigate("/dashboard");
            } else if (localStorage.getItem("role") == "branch") {
              navigate("/add-fund");
            } else {
              localStorage.removeItem("user_id");
              localStorage.removeItem("role");
              localStorage.removeItem("name");
              localStorage.removeItem("token");
              localStorage.removeItem("email");
              localStorage.removeItem("city");
              window.location = imageUrl;
            }
          }).catch((error) => {
            toast.error(error?.ResponseMsg)
          })
        // navigate("/dashboard")
      } else {
        dispatch(verifyOTP({
          otp: values?.otp
        })).unwrap()
          .then((res) => {
            navigate('/reset_password', {
              state: {
                verified: true
              }
            })
          }).catch((error) => {
            // navigate('/reset_password', {
            //   state: {
            //     verified: true
            //   }
            // })
          })
      }

    }
  })
  const handleResendOTP = () => {
    dispatch(forgot_password({
      email: state?.email
    }))
  }
  return (
    <>
      <div className="grid sm:grid-cols-2 grid-cols-1 justify-center sm:h-screen h-full items-center w-full bg-mainBG">
        <div className="max-md:px-5 flex flex-col items-center justify-center sm:py-0 py-10 space-y-10 md:space-y-36">
          <div>
            <img
              // className="w-[344px] h-[436px] "
              src={`${imageUrl}images/Authentication.png`}
              alt="hand-logo"
            />
          </div>
          {/* <div className="lg:px-0 md:px-5">
            <h1 className="text-3xl xs:text-[34px] max-md:leading-[44px] md:text-4xl font-bold text-[#fff] text-center">
              lorem ipsum dummy text
            </h1>
            <p className="text-lg md:text-2xl mt-2 text-[#fff] font-normal text-center  lg:w-[492px]">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry.
            </p>
          </div> */}
        </div>
        <div className="w-full max-md:px-5 flex flex-col items-center justify-center bg-white h-screen ">
          <div className="flex justify-center mb-14">
            <img src={`${imageUrl}images/AuthenticationIcon.png`} alt="lock" />
          </div>
          <form className="w-full">
            <h2 className="text-mainBG text-3xl md:text-1xl  font-semibold text-center">
              Authentication
            </h2>
            <div className="flex justify-center">
              <p className="text-lg mt-4 font-medium text-textHeading text-center md:w-[336px] w-full">
                Enter the verification code we just sent to your email address.
              </p>
            </div>
            <div className="mt-5 flex  justify-center items-center   w-full">
              <div className="flex flex-col items-center space-y-8 md:w-[360px] w-full">
                <div className="flex gap-x-4">
                  <OTPInput
                    value={formik.values.otp}
                    onChange={(value) => {
                      formik.setFieldValue("otp", value); // Update formik value
                    }}
                    numInputs={4}
                    skipDefaultStyles
                    containerStyle="justify-start gap-x-5 mt-7"
                    renderInput={(props) => {
                      return (
                        <input
                          {...props}
                          type="number"
                          className="w-full  max-h-[70px]  outline-none focus:border-border text-center placeholder:text-secondary text-[#1D3557] py-3.5 rounded-xl bg-inputBG  border border-[#E7E6E9]"
                        />
                      );
                    }}
                  />
                  {/* {otp.map((value, index) => (
                    <OTPInput
                      key={index}
                      id={`otp-${index}`}
                      name={`otp-${index}`}
                      prevElement={index > 0 ? `otp-${index - 1}` : null}
                      nextElement={
                        index < otp.length - 1 ? `otp-${index + 1}` : null
                      }
                      onChange={(e) => handleChange(index, e.target.value)}
                    />
                  ))} */}
                </div>
                {formik.touched.otp && formik.errors.otp ? (
                  <div className="text-red-500 mt-2 text-start">
                    {formik.errors.otp}
                  </div>
                ) : null}
                <Button
                  text={loading ? <ButtonLoading /> : "Verify Code"}
                  className="py-4 rounded-[10px] flex justify-center font-semibold text-xl w-full"
                  type={true}
                  onClick={formik.handleSubmit}
                ></Button>
                <div className="mt-4 ml-2">
                  <p className="text-lg font-normal">Didn't receive the code? <span className="text-mainBG font-semibold cursor-pointer" onClick={handleResendOTP}> Resend </span> </p>
                </div>
              </div>

            </div>
            <div className="flex justify-center mt-20 ">
              <Link
                className="flex items-center gap-3 text-[#808080]  text-lg font-normal"
                to="/"
              >
                <GoArrowLeft /> <span>Back to Sign In</span>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default VerifyOtp;
